const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/sagas/index.ts';
import { all, call, put } from 'redux-saga/effects';
import { showUncaughtErrorDialog } from '@cistec/common_web/actions/uiActions';
import CIS4mSaga from '@cistec/common_web/modules/CIS4m/saga';
import { intlSaga } from '@cistec/common_web/sagas/intlSaga';
import { nativeEventsSaga } from './nativeEventsSaga';
import { autoLoginSaga } from './autoLoginSaga';
import { appointmentsSaga } from './appointment';
import { trackingSaga } from './trackingSaga';
import nativeSaga from './nativePort';
import { nativeAppAuthSaga } from './nativeAppAuthSaga';
import { hasNativeWrapper } from 'App/utils/generalUtils';
import { snackbarSaga } from './snackbar';

export default function* root(): IterableIterator<any> {
    try {
        const sagas = [
            appointmentsSaga,
            snackbarSaga,
            autoLoginSaga,
            trackingSaga,
            hasNativeWrapper ? nativeEventsSaga : undefined,
            hasNativeWrapper ? nativeSaga : undefined,
            hasNativeWrapper ? nativeAppAuthSaga : undefined,
            CIS4mSaga,
            intlSaga,
        ];

        yield all(sagas.map(s => (s ? call(s) : undefined)).filter(s => !!s));
    } catch (exc) {
        yield put(showUncaughtErrorDialog('SagaIndex', exc));
        // TODO LogError
    }
}
